import { default as saveAs } from "save-as";

import { ExportableArray, ExportMetadata } from "../export";
import { formatFileNameForExport } from "../formatting";
import * as XLSXUtils from "../xlsx";

import { forEach } from "./source";
import { DataView } from "./view";

interface ExportColumn<ITEM> {
    label: string;
    getValue: (item: ITEM) => string | number | undefined;
}

function exportToTable<ITEM>(
    dataView: DataView<ITEM>,
    filterItem: (item: ITEM) => boolean,
    columns: Array<ExportColumn<ITEM>>
): ExportableArray {
    const table: Array<Array<string | number | undefined>> = [];
    const header: Array<string> = [];
    columns.forEach((column) => {
        header.push(column.label);
    });
    forEach(dataView.dataSource.iter(), (item) => {
        if (filterItem(item)) {
            const row: Array<string | number | undefined> = [];
            columns.forEach((column) => {
                row.push(column.getValue(item));
            });
            table.push(row);
        }
    });
    return { header, content: table };
}

function exportToExcel<ITEM>(
    dataView: DataView<ITEM>,
    filterItem: (item: ITEM) => boolean,
    columns: Array<ExportColumn<ITEM>>,
    fileName: string,
    ext: string,
    worksheetName: string,
    metadata: ExportMetadata
) {
    const exportableArray = exportToTable(dataView, filterItem, columns);
    const worksheet = XLSXUtils.tableToWorksheet(
        exportableArray,
        undefined,
        metadata
    );
    const workbook = XLSXUtils.workbookWithSingleWorksheet(
        worksheetName,
        worksheet
    );
    const data = XLSXUtils.workbookToBinary(workbook);
    const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, formatFileNameForExport(fileName, ext));
}

export { type ExportColumn, exportToTable, exportToExcel };
